import styled from "styled-components";

export const StyledHeader = styled.h1`
    font-family: 'Palette Mosaic', monospace;
    font-size: 3.5rem;
    text-shadow: 3px 3px #9036AA;
`;